import * as types from 'modules/devices/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const open = () => true;
const hide = () => false;

export default createReducer<boolean>(initialState, {
  [types.OPEN_CREATE_DEVICE_MODAL]: open,
  [types.HIDE_CREATE_DEVICE_MODAL]: hide,
  [LOCATION_CHANGE]: hide,
});
